import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { notification } from "../app/schema";

export const PATCH_NOTIFICATION = "PATCH_NOTIFICATION";
export const PATCH_NOTIFICATION_SUCCESS = "PATCH_NOTIFICATION_SUCCESS";
export const PATCH_NOTIFICATION_ERROR = "PATCH_NOTIFICATION_ERROR";

// Requests

const patchNotification = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v2/notifications/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

// Actions

export function updateNotification(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_NOTIFICATION],
    payload: {
      promise: patchNotification(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, notification);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/notifications/actions.js